/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is XLSX support the same as complete Excel compatibility?`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 XLSX 就等于完全兼容 Excel 吗？`)
};

/**
* | output |
* | --- |
* | "Is XLSX support the same as complete Excel compatibility?" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_question as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.1.question" }